import { mapGetters } from 'vuex';
import { app } from '@microsoft/teams-js';
import { msalActions } from '@/components/ms-teams/MSAL';
import { GraphAPI } from '@/components/ms-teams/GraphAPI';
import MsTeamsConfigurationService from '@/services/msTeamsConfigurationService';

export default {
  name: 'MSTeamsMixing',

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),
    ...mapGetters('ORGANIZATION', ['orgId'])
  },

  created() {
    this.$root.$on('teams.msal.signIn', msalActions.signIn);
    this.$root.$on('teams.graph.getPresence', GraphAPI.presence.get);
    this.$root.$on('teams.graph.getSubscriptions', GraphAPI.subscriptions.get);
    this.$root.$on('teams.graph.subscribePresence', this.subscribeToPresenceChanges);
    this.$root.$on('teams.graph.deleteSubscriptions', GraphAPI.subscriptions.delete);
  },

  destroyed() {
    this.$root.$off('teams.msal.signIn', msalActions.signIn);
    this.$root.$off('teams.graph.getPresence', GraphAPI.presence.get);
    this.$root.$off('teams.graph.getSubscriptions', GraphAPI.subscriptions.get);
    this.$root.$off('teams.graph.subscribePresence', this.subscribeToPresenceChanges);
    this.$root.$off('teams.graph.deleteSubscriptions', GraphAPI.subscriptions.delete);
  },

  methods: {
    getMsTeamsConfiguration() {
      return MsTeamsConfigurationService.get(this.orgId).then(response => response.data);
    },

    async subscribeToPresenceChanges() {
      if (!this.loggedInAgent || !this.orgId) {
        return setTimeout(this.subscribeToPresenceChanges, 200);
      }

      try {
        const msTeamsConfiguration = await this.getMsTeamsConfiguration();

        msalActions.setConfiguration(msTeamsConfiguration, async () => {
          await app.getContext();
          await msalActions.signIn();
          const subscriptions = await GraphAPI.subscriptions.get();

          if (!subscriptions.value || subscriptions.value.length === 0) {
            GraphAPI.subscriptions.subscribe({
              agentId: this.loggedInAgent.id,
              orgId: this.orgId,
              notificationsUrl: msTeamsConfiguration.notificationsUrl
            });
          }
        });
      } catch (error) {
        // Running in a browser without the Teams client will throw the following error:
        // The library has not yet been initialized.
        // Therefore, there are no additional actions to take.
      }
    }
  }
};
